export const manualBankFormSteps = [
    {
        target: '[data-tour="bank-form-name"]',
        content: 'Enter your Bank Name (e.g., “Chase Business”)',
        placement: 'bottom',
        disableBeacon: false,
    },
    {
        target: '#bank-form-type-container',
        content:
            'Choose the Account Type: select either Depository (for checking/savings) or Credit (for credit cards)',
        placement: 'left',
        disableBeacon: false,
        disableOverlay: true,
    },
    {
        target: '#bank-form-detail-type-container',
        content:
            ' Pick a Detail Type: either Checking or Savings for Depository accounts and Credit for Credit Card',
        placement: 'right',
        disableOverlay: true,
        disableBeacon: false,
    },
    {
        target: '[data-tour="bank-form-mask-number"]',
        content:
            'Input the last 4 digits of your bank account number — this helps identify the account but keeps it secure',
        placement: 'bottom',
        disableBeacon: false,
    },
    {
        target: '[data-tour="bank-form-submit"]',
        content: 'Click “Create” to finish adding your manual account.',
        placement: 'bottom',
        disableBeacon: false,
    },
];
